// BarmetHub Version — increment on each release
// Format: MAJOR.MINOR (e.g., 1.01, 1.02, 2.00)
export const APP_VERSION = '1.83';
